/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IPriceRequestDetailsFragment = { __typename?: 'PriceRequest' } & Pick<
  Types.IPriceRequest,
  | 'id'
  | 'additionalStops'
  | 'createdAt'
  | 'customerQuote'
  | 'customerQuoteType'
  | 'deliveryCity'
  | 'deliveryDropTrailer'
  | 'deliveryStartDate'
  | 'deliveryStartTime'
  | 'deliveryStateCode'
  | 'deliveryZipcode'
  | 'equipmentId'
  | 'externalId'
  | 'isTestQuote'
  | 'isDrop'
  | 'pickupCity'
  | 'pickupDropTrailer'
  | 'pickupStartDate'
  | 'pickupStartTime'
  | 'pickupStateCode'
  | 'pickupZipcode'
  | 'shipperApplicationId'
  | 'shipperMiles'
  | 'source'
  | 'isDoNotBidApplied'
  | 'updatedAt'
> & {
    premiums?: Types.Maybe<
      { __typename?: 'PriceRequestPremium' } & Pick<
        Types.IPriceRequestPremium,
        'commodity' | 'quoteWithFuel' | 'quoteWithoutFuel'
      >
    >
    pricingResponse?: Types.Maybe<
      { __typename?: 'PricingResponse' } & Pick<
        Types.IPricingResponse,
        | 'datMiles'
        | 'datRate'
        | 'highDatRate'
        | 'lowDatRate'
        | 'tcm50'
        | 'tcm40'
        | 'tcm75'
        | 'tcm25'
      >
    >
    shipperApplication?: Types.Maybe<
      { __typename?: 'ShipperApplication' } & Pick<Types.IShipperApplication, 'id' | 'name'>
    >
    requestedBy?: Types.Maybe<
      { __typename?: 'User' } & Pick<Types.IUser, 'firstName' | 'lastName' | 'id' | 'userType'>
    >
  }

export const PriceRequestDetailsFragmentDoc = gql`
  fragment PriceRequestDetails on PriceRequest {
    id
    additionalStops
    createdAt
    customerQuote
    customerQuoteType
    deliveryCity
    deliveryDropTrailer
    deliveryStartDate
    deliveryStartTime
    deliveryStateCode
    deliveryZipcode
    equipmentId
    externalId
    isTestQuote
    isDrop
    pickupCity
    pickupDropTrailer
    pickupStartDate
    pickupStartTime
    pickupStateCode
    pickupZipcode
    premiums {
      commodity
      quoteWithFuel
      quoteWithoutFuel
    }
    pricingResponse {
      datMiles
      datRate
      highDatRate
      lowDatRate
      tcm50
      tcm40
      tcm75
      tcm25
    }
    shipperApplication {
      id
      name
    }
    requestedBy {
      firstName
      lastName
      id
      userType
    }
    shipperApplicationId
    shipperMiles
    source
    isDoNotBidApplied
    updatedAt
  }
`
